import React from 'react';
import './Paragraph.scss';

interface PProps {
  color?:
    | 'text-01'
    | 'text-02'
    | 'ads-color-disabled'
    | 'placeholder'
    | 'savings'
    | 'link'
    | 'inverse';
  detail?: boolean;
  detailColor?: 'ads-color-inverse';
  disabled?: boolean;
  hidden?: boolean;
  short?: boolean;
  small?: boolean;
  shortSmall?: boolean;
  type?:
    | 'ads-paragraph--short'
    | 'ads-paragraph__small'
    | 'ads-paragraph--short__small';
}

export const P: React.FC<PProps> = ({
  children,
  color,
  detail,
  detailColor,
  disabled,
  hidden,
  short,
  small,
  shortSmall
}) => {
  return detail ? (
    <p
      className={`ads-paragraph__detail ${detailColor} ${
        hidden ? 'hidden' : ''
      }`}
      data-testid="ads-paragraph__detail"
      aria-disabled={disabled && true}
    >
      {children}
    </p>
  ) : (
    <p
      className={`
        ads-paragraph 
        ${short ? 'ads-paragraph--short' : ''} 
        ${small ? 'ads-paragraph__small' : ''} 
        ${shortSmall ? 'ads-paragraph--short__small' : ''} 
        ${color === 'text-01' ? 'ads-color-text-01' : ''} 
        ${color === 'text-02' ? 'ads-color-text-02' : ''} 
        ${color === 'placeholder' ? 'ads-color-placeholder' : ''} 
        ${color === 'savings' ? 'ads-color-savings' : ''} 
        ${color === 'link' ? 'ads-color-link' : ''}
        ${color === 'inverse' ? 'ads-color-inverse' : ''}
        ${hidden ? 'hidden' : ''}
        ${disabled ? 'ads-color-disabled' : ''}
      `}
      data-testid="ads-paragraph"
      aria-disabled={disabled && true}
    >
      {children}
    </p>
  );
};
